import Backbone from 'backbone';
import viewerSocialProfile from 'models/user/ViewerSocialProfile';

var Preferences = Backbone.Model.extend({
    url: function() {
        //this is the endpoint for configuration preferences from web-modern
        return '/modern/preference/' + this.key;
    },

    initialize: function(args) {
        this.key = args.key;
    },

    featureEnabled: function() {
        return (
            viewerSocialProfile.get('userRoles') && viewerSocialProfile.get('userRoles').indexOf(this.get('value')) >= 0
        );
    },

    getFeatureEnabledForMultipleRoles: function() {
        var userRoles = viewerSocialProfile.get('userRoles');
        var userRolesList = this.get('value')?.split(',') || [];
        var val = false;
        for (var i = 0; i < userRolesList.length; i++) {
            val = val || !!(userRoles && userRoles.indexOf(userRolesList[i].trim()) >= 0);
        }
        return val;
    }
});

export default Preferences;
